<template>
  <v-menu 
    :close-on-content-click="false"
    :nudge-bottom="3"
    :nudge-left="40"
    :value="showTprCalendar"
    bottom
    offset-y>
    <template #activator="{ on: menu, attrs }">
      <v-tooltip top>
        <template #activator="{ on: tooltip }">
          <v-btn 
            v-if="canUseCalendar"
            small
            @click="showTprCalendar = true"
            class="grey lighten-2 ml-2"
            height="38"
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }">
            <v-icon>mdi-calendar</v-icon>
          </v-btn>
        </template>
        <span>TPR Interactive Schedule</span>
      </v-tooltip>
    </template>

    <v-card class="fill" width="360">
      <v-card-title class="pb-0 text-subtitle-1">
        TPR Interactive Schedule
      </v-card-title>
      <v-card flat align="center">
        <v-form ref="s_form" class="fill">
          <v-divider />
          <v-date-picker
            :allowed-dates="(date) => new Date(date).getDay() === 6"
            :show-current="true"
            :events="eventDates"
            :event-color="getEventColorForDate"
            show-adjacent-months
            color="primary"
            no-title
            v-model="interactiveDateSelection"
            full-width>
          </v-date-picker>
          <v-divider />
        </v-form>
      </v-card>
      <v-card 
        v-if="interactiveDateSelection"
        flat>
        <v-card-title class="text-h6">
          TPR Date: {{ interactiveDateSelection }}
        </v-card-title>
        <v-card-text>
          <p 
            v-for="event in eventData"
            :key="event.name"
            class="black--text">
            <v-chip :color="event.color" small dark class="mr-2 event-chip-width">
              {{ event.name }}
            </v-chip>
            {{ event.value }} @ {{ event.time }}
          </p>
          <p class="mb-0">* Publishing also generates Export 25 and Storewise files</p>
        </v-card-text>
      </v-card>
    </v-card>
  </v-menu>
</template>

<script>
import { userAccess } from '@/mixins/user-access'

export default {
  name: 'TPR-Calendar',
  components: {},
  mixins: [userAccess],

  data() {
    return {
      interactiveDateSelection: null,
      showTprCalendar: false,
      nonPerGenLookback: 26,
      perGenLookback: 19,
      nonPerPublishLookback: 19,
      perPublishLookback: 13,
      nTouchLookback: 11,
      hostFileStartLookback: 5,
      hostFileEndLookback: -1,
    }
  },
  computed: {
    canUseCalendar() {
      return ['tpr-manager.admin', 'arg-category-manager', 'arg-group-manager'].some(role => this.userGroups.includes(role)) && ['alliance-retail-group'].includes(this.$auth.tenant)
    },
    eventData() {
      if (this.interactiveDateSelection == null)
        return []

      return [
        { name: "Non Perishable Generated", time: "6:00 PM", color: "green", value: this.dateSubtract(this.nonPerGenLookback) },
        { name: "Non Perishable Published *", time: "1:00 AM", color: "yellow darken-2", value: this.dateSubtract(this.nonPerPublishLookback) },
        { name: "Perishable Generated", time: "6:00 PM", color: "yellow darken-2", value: this.dateSubtract(this.perGenLookback) },
        { name: "Perishable Published *", time: "1:00 AM", color: "blue lighten-1", value: this.dateSubtract(this.perPublishLookback) },
        { name: "nTouch File Generated", time: "2:30 PM", color: "red lighten-1", value: this.dateSubtract(this.nTouchLookback) },
        { name: "Host Files Start", time: "7:30 AM", color: "purple lighten-3", value: this.dateSubtract(this.hostFileStartLookback) },
        { name: "Host Files Stop", time: "7:30 AM", color: "purple lighten-3", value: this.dateSubtract(this.hostFileEndLookback) },
      ]
    },
    eventDates() {
      if (this.interactiveDateSelection == null)
        return []

      return this.eventData.flatMap(item => item.value)
    }
  },
  watch: {
  },
  created() {
    
  },
  methods: {
    dateSubtract( lookBack) {
      if (this.interactiveDateSelection == null) {
        return ""
      }

      const date = new Date(this.interactiveDateSelection + 'T00:00:00')
      date.setDate(date.getDate() - lookBack)
      return date.toISOString().split('T')[0]
    },
    getEventColorForDate(date) {
      const event = this.eventData.find(event => event.value === date)
      return event ? event.color : 'black'
    },
    getEventColorForName(name) {
      const event = this.eventData.find(event => event.name === name)
      return event ? event.color : 'black'
    }
  }
}
</script>
<style>
.event-chip-width {
  width: 170px !important;
  justify-content: center;
  color: black !important;
}
</style>